module.exports = {
      id: "pdf-usage",
      viewBox: "0 0 21.946 21.946",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#pdf",
      toString: function () {
        return this.url;
      }
    }